<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("common.overview") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <!-- STUDENT INFORMATION -->
        <div v-if="!!studentInfo" class="md-layout-item md-size-100 px-0">
          <information-area
            :title="$t('attendance_report.student.area_student_information')"
          >
            <template #content>
              <student-information :studentInfo="studentInfo">
                <template v-if="extraStudentInfo" #extra-info>
                  <p class="font-normal">
                    {{ $t("common.grade") }}: {{ extraStudentInfo.grade }}
                  </p>
                  <p class="font-normal">
                    {{ $t("attendance_report.student.enrollment_classes") }}:
                    {{ extraStudentInfo.enrolledClasses }}
                  </p>
                </template>
              </student-information>
            </template>
          </information-area>
        </div>
        <!-- STUDENT INFORMATION -->

        <!-- ATTENDANCE -->
        <div
          v-if="!!attendanceData"
          class="md-layout-item md-size-40 md-medium-size-100 px-0 mt-6"
        >
          <information-area
            :title="$t('attendance_report.student.area_student_attendance')"
          >
            <template #content>
              <attendance-chart :attendance-data="attendanceData">
              </attendance-chart>
            </template>
          </information-area>
        </div>
        <!-- ATTENDANCE -->

        <div
          v-if="!!presentPercentage"
          class="md-layout-item md-size-60 md-medium-size-100 px-0 mt-6"
        >
          <information-area
            :title="
              $t('attendance_report.student.area_student_attendance_by_periods')
            "
          >
            <template #content>
              <period-attendances
                :present-percentage="presentPercentage"
              ></period-attendances>
            </template>
          </information-area>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { InformationArea, StudentInformation } from "@/pages/Report/Components";
import {
  AttendanceChart,
  PeriodAttendances
} from "@/pages/Report/Attendance/Components";

export default {
  components: {
    InformationArea,
    AttendanceChart,
    StudentInformation,
    PeriodAttendances
  },
  inject: ["reportData"],
  computed: {
    attendanceData() {
      return this.reportData.attdOverview;
    },
    presentPercentage() {
      return this.reportData.attdPercentage;
    },
    studentInfo() {
      return this.reportData.studentInfo?.user_no_sql;
    },
    extraStudentInfo() {
      if (!this.studentInfo) return null;

      return {
        grade: this.studentInfo.grade,
        enrolledClasses: this.studentInfo.classes?.length
      };
    }
  },
  methods: {
    getClassRow(item) {
      if (item.isSumRow) return "sum-row font-semibold";

      return "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
